import { useId } from 'react';
import DatePicker from './DatePicker';

export default function DateRangeFields({
  from,
  to,
  onFromChange,
  onToChange,
}: {
  from?: string;
  to?: string;
  onFromChange: (value: string | undefined) => void;
  onToChange: (value: string | undefined) => void;
}) {
  const id = useId();
  return (
    <div className="grid w-full min-w-0 grid-cols-1 gap-2 sm:w-auto sm:grid-cols-2">
      <div className="min-w-0 space-y-1">
        <label htmlFor={`${id}-from`} className="text-xs font-medium text-muted-foreground">
          From
        </label>
        <DatePicker
          id={`${id}-from`}
          aria-label="From date"
          value={from}
          onChange={onFromChange}
          placeholder="Start date"
        />
      </div>
      <div className="min-w-0 space-y-1">
        <label htmlFor={`${id}-to`} className="text-xs font-medium text-muted-foreground">
          To
        </label>
        <DatePicker
          id={`${id}-to`}
          aria-label="To date"
          value={to}
          onChange={onToChange}
          placeholder="End date"
        />
      </div>
    </div>
  );
}
